import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CommonService } from "../services/common.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
@Component({
  selector: "app-step",
  templateUrl: "./step.component.html",
  styleUrls: ["./step.component.scss"],
  encapsulation: ViewEncapsulation.None, // 🔥 esto es clave
})
export class StepComponent implements OnInit {
  asks = [];
  commit = "";
  recomendation;
  respLow = "";
  respMid = "";
  respHigth = "";
  escala;
  objective = [
    "Control de peso.",
    "Estar en forma, saludable.",
    "Fuerza y definición.",
    "Rendimiento deportivo.",
  ];
  objective1 = [
    "Controle do peso",
    "Estar em forma, saudável.",
    "Força e definição.",
    "Rendimento desportivo",
  ];

  objective2 = [
    "Weight management.",
    " To be fit, healthy.",
    " Strength and definition.",
    "Sports Performance.",
  ];

  objective3 = [
    "Controllo del peso.",
    "Essere in forma e in salute.",
    "Forza e definizione.",
    "Prestazioni sportive.",
  ];
  questions;
  opcion = "";
  respZone: any = [];
  respZone2: any = [];
  respObj = [];
  low = false;
  mid = false;
  higth = false;
  selectRecomendation: string;
  optionRecomendation: string[] = ["Si", "no"];
  optionRecomendation1: string[] = ["Yes", "no"];
  optionRecomendation2: string[] = ["Sim", "Não"];
  optionRecomendation3: string[] = ["Sì", "No"];
  selectObjetive: string;

  zone = [
    {
      id: 1,
      text: "Sala fitness: fuerza y peso libre",
      isChecked: false,
      idioma: "esp",
    },
    { id: 2, text: "Sala cardio", isChecked: false, idioma: "esp" },
    { id: 3, text: "Actividades dirigidas", isChecked: false, idioma: "esp" },
    { id: 4, text: "Piscina", isChecked: false, idioma: "esp" },
    { id: 5, text: "Zona Spa", isChecked: false, idioma: "esp" },
    { id: 6, text: "Pistas de pádel / tenis", isChecked: false, idioma: "esp" },
    { id: 7, text: "En el exterior", isChecked: false, idioma: "esp" },
    { id: 8, text: "Otras salas", isChecked: false, idioma: "esp" },
    {
      id: 1,
      text: "Sala fitness: força e peso livre",
      isChecked: false,
      idioma: "por",
    },
    { id: 2, text: "Equipamento Cardio", isChecked: false, idioma: "por" },
    { id: 3, text: "Aulas de grupo", isChecked: false, idioma: "por" },
    { id: 4, text: "Piscina", isChecked: false, idioma: "por" },
    { id: 5, text: "SPA", isChecked: false, idioma: "por" },
    { id: 6, text: "Campos de Padel", isChecked: false, idioma: "por" },
    { id: 7, text: "No exterior", isChecked: false, idioma: "por" },
    { id: 8, text: "Outras salas", isChecked: false, idioma: "por" },
    {
      id: 1,
      text: "Fitness room: strength and free weight",
      isChecked: false,
      idioma: "eng",
    },
    { id: 2, text: "cardio room", isChecked: false, idioma: "eng" },
    { id: 3, text: "Guided activities", isChecked: false, idioma: "eng" },
    { id: 4, text: "Pool", isChecked: false, idioma: "eng" },
    { id: 5, text: "Spa area", isChecked: false, idioma: "eng" },
    { id: 6, text: "Padel / tennis courts", isChecked: false, idioma: "eng" },
    { id: 7, text: "Outdoor", isChecked: false, idioma: "eng" },
    { id: 8, text: "Other rooms", isChecked: false, idioma: "eng" },
    {
      id: 1,
      text: "Sala fitness: forza e pesi liberi",
      isChecked: false,
      idioma: "ita",
    },
    { id: 2, text: "Sala cardio", isChecked: false, idioma: "ita" },
    { id: 3, text: "Attività guidate", isChecked: false, idioma: "ita" },
    { id: 4, text: "Piscina", isChecked: false, idioma: "ita" },
    { id: 5, text: "Area Spa", isChecked: false, idioma: "ita" },
    { id: 6, text: "Campo da padel/tennis", isChecked: false, idioma: "ita" },
    { id: 7, text: "All’esterno", isChecked: false, idioma: "ita" },
    { id: 8, text: "Altre sale", isChecked: false, idioma: "ita" },
  ];
  zoneFit = [
    {
      id: 1,
      text: "Zona de iniciaci\xf3n para el trabajo de fuerza (hay dos TVs de ayuda) (STARTING POINT)",
      isChecked: false,
      idioma: "esp",
    },
    {
      id: 2,
      text: "Zona de calentamiento y estiramiento. (RECOVERY ZONE)",
      isChecked: false,
      idioma: "esp",
    },
    {
      id: 3,
      text: "Zona de entrenamiento funcional. (TRAINING EXPERIENCE ZONE)",
      isChecked: false,
      idioma: "esp",
    },
    {
      id: 4,
      text: "Zona prepara para el entrenamiento de potencia con grandes cargas. (LIFT ZONE)",
      isChecked: false,
      idioma: "esp",
    },
    {
      id: 5,
      text: "Zona de peso libre. (PESO LIBRE)",
      isChecked: false,
      idioma: "esp",
    },
    {
      id: 6,
      text: "Zona para el entrenamiento de la aptitud cardio-pulmonar. (ZONA CARDIOVASCULAR)",
      isChecked: false,
      idioma: "esp",
    },
    {
      id: 7,
      text: "Zona de fuerza con m\xe1quinas guiadas de diferentes grupos musculares. (ZONA DE M\xc1QUINAS SELECTORIZADAS)",
      isChecked: false,
      idioma: "esp",
    },
    {
      id: 1,
      text: "Zona de STARTING POINT para o trabalho de for\xe7a (existem dois televisores para assist\xeancia)",
      isChecked: false,
      idioma: "por",
    },
    {
      id: 2,
      text: "Zona de aquecimento e de alongamentos (RECOVERY ZONE)",
      isChecked: false,
      idioma: "por",
    },
    {
      id: 3,
      text: "Zona de treino funcional (TRAINING EXPERIENCE ZONE)",
      isChecked: false,
      idioma: "por",
    },
    {
      id: 4,
      text: "Zona preparada para o treino de for\xe7a com pesos pesados (LIFT ZONE)",
      isChecked: false,
      idioma: "por",
    },
    {
      id: 5,
      text: "Zona de pesos livres (PESO LIVRE)",
      isChecked: false,
      idioma: "por",
    },
    {
      id: 6,
      text: "Zona para treino de aptid\xe3o cardio-pulmonar (CARDIOVASCULAR ZONE).",
      isChecked: false,
      idioma: "por",
    },
    {
      id: 7,
      text: "Zona de for\xe7a com m\xe1quinas orientadas para diferentes grupos musculares (\xc1REA DE M\xc1QUINAS SELECCIONADAS)",
      isChecked: false,
      idioma: "por",
    },
    {
      id: 1,
      text: "Zona di avviamento per il lavoro di forza (ci sono due TV di supporto) (STARTING POINT)",
      isChecked: false,
      idioma: "ita",
    },
    {
      id: 2,
      text: "Zona di riscaldamento e stretching. (RECOVERY ZONE)",
      isChecked: false,
      idioma: "ita",
    },
    {
      id: 3,
      text: "Zona di allenamento funzionale. (TRAINING EXPERIENCE ZONE)",
      isChecked: false,
      idioma: "ita",
    },
    {
      id: 4,
      text: "Zona preparata per l'allenamento di potenza con carichi elevati. (LIFT ZONE)",
      isChecked: false,
      idioma: "ita",
    },
    {
      id: 5,
      text: "Zona pesi liberi. (PESO LIBRE)",
      isChecked: false,
      idioma: "ita",
    },
    {
      id: 6,
      text: "Zona per l'allenamento dell'aptitudine cardio-polmonare. (ZONA CARDIOVASCULAR)",
      isChecked: false,
      idioma: "ita",
    },
    {
      id: 7,
      text: "Zona di forza con macchine guidate per diversi gruppi muscolari. (ZONA DE M\xc1QUINAS SELECTORIZADAS)",
      isChecked: false,
      idioma: "ita",

    },
  ];
  lang;
  step = 0;
  loading = true;
  flag;
  survey;
  centro;
  aux: any = [];
  aux2: any = [];
  start = false;
  isMobile = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private common: CommonService,
    private _snackBar: MatSnackBar,
    private breakpointObserver: BreakpointObserver
  ) { }

  async home() {
    await this.route.params.subscribe(async (parameter: any) => {
      console.log(parameter);

      if (!parameter.id) {
        this.loading = false;
        this.flag = false;
        console.log("no existe parametro id");
      } else {
        console.log("otra cos");
        // this.loading = false;
        // localStorage.setItem("BQT.token", parameter.id);
        window.sessionStorage.setItem("BQT.token", parameter.id);
        this.common
          .getSurveyFirst()
          .then((res: any) => {
            console.log("por aqui");
            console.log(res);
            this.start = true;
            this.centro = res.survey.relationCustomer.centro;
            console.log(this.centro);
            if (res.ok === false) {
              console.log("por aqui");
              this.flag = false;
              return;
            }
            console.log("por aqui");

            this.flag = true;
            let auxEscala = res.survey.answers.escala;
            console.log(auxEscala);

            if (auxEscala != 11) {
              this.escala = auxEscala;
              this.asks[auxEscala] = auxEscala;
              this.step = 0.5;
              if (auxEscala >= 0 && auxEscala <= 6) {
                this.commit = res.survey.answers.commit;
                this.low = true;
                this.mid = false;
                this.higth = false;
                this.step = 1;
              }

              if (auxEscala >= 7 && auxEscala <= 8) {
                this.commit = res.survey.answers.commit;
                this.mid = true;
                this.low = false;
                this.higth = false;
                this.step = 1;
              }

              if (auxEscala >= 9 && auxEscala <= 10) {
                this.commit = res.survey.answers.commit;
                this.higth = true;
                this.mid = false;
                this.low = false;
                this.step = 1;
              }
            }
            console.log(res.survey.answers.zones);
            let arr = res.survey.answers.zones.split(",");
            for (const a of arr) {
              this.zone.forEach((element) => {
                if (a === element.text) {
                  console.log(element);
                  element.isChecked = true;
                  this.step = 2;
                }
              });
            }

            this.respObj = res.survey.answers.commit;
            this.selectRecomendation = res.survey.answers.recomendacion;
            if (this.selectRecomendation != "") {
              this.step = 3;
            }

            this.selectObjetive = res.survey.answers.objetivo;

            this.loading = false;
            this.flag = true;
            this.survey = res.survey;
            // settear idioma segun pais
            if (this.survey.pais != undefined) {
              if (this.survey.pais != "") {
                if (this.survey.pais == "España") {
                  this.lang = "esp";
                  localStorage.setItem("idioma", "esp");
                } else if (this.survey.pais == "Portugal") {
                  this.lang = "por";
                  localStorage.setItem("idioma", "por");
                  this.changeFlag(this.lang);
                } else if (this.survey.relationCustomer.pais.toLowerCase() == "italia") {
                  this.lang = "ita";
                  localStorage.setItem("idioma", "ita");
                  this.changeFlag(this.lang);
                }

              } else {
                this.lang = "esp";
                localStorage.setItem("idioma", "esp");
              }
            }
            let ar = [];
            let index = 1;
            let xvalue = null;
            for (let field of res.fields) {
              if (field.type == "numero" || field.type == "escala") {
                xvalue = null;
              }

              if (field.type == "textarea") {
                xvalue = "";
              }

              let json = {
                key: "p" + index,
                name: field.name,
                type: field.type,
                optional: "",
                value: xvalue,
              };
              console.log(json);

              ar.push(json);
              index++;
            }
            console.log(ar);

            this.questions = ar;
            // localStorage.setItem("preguntas", JSON.stringify(ar));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }
  startSurvey() {
    console.log("iniciar encuesta");
    this.router.navigate(["/step", { page: 0 }]);
  }

  async ngOnInit() {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isMobile = result.matches;
        console.log("¿Es móvil?", this.isMobile);
      });
    await this.home();
    await this.otro();
  }

  // updateText(i, t) {
  //   console.log(i, t.target.value);
  //   this.asks[2] = {commit:t.target.value};
  // }

  async otro() {
    this.questions = localStorage.getItem("preguntas");
    this.lang = localStorage.getItem("idioma");
    this.questions = JSON.parse(this.questions);
    console.log(this.questions);
    this.zone.sort(() => Math.random() - 0.5);
    this.objective.sort(() => Math.random() - 0.5);
    console.log();
  }

  showZoneFit() {
    return this.zone.some((z) => z.id === 1 && z.idioma === this.lang && z.isChecked);
  }

  updateRadio2(field) {
    console.log(field.value);
    this.step = 3;
    this.respObj = field.value;
    this.aux = this.zone.filter((z) => z.isChecked == true).map((z) => z.text);
    this.aux2 = this.zoneFit.filter((z) => z.isChecked == true).map((z) => z.text);
    let resp = {
      escala: this.escala,
      commit: this.commit,
      zones: this.aux.toString(),
      zoneFitness: this.aux2.toString(),
      recomendacion: this.opcion,
      objetivo: this.respObj,
    };
    console.log(resp);
    console.log(this.centro);
    this.common.noFinishSurvey(resp).then((res: any) => {
      console.log(res);
    });
  }

  someComplete(id: any) {
    console.log(id);
    this.step = 2;
    if (this.zone == null) {
      return false;
    }
    this.respZone = this.zone.filter((t) => t.isChecked == true);
    console.log(this.respZone);

    for (const r of this.respZone) {
      if (r.isChecked == true) {
        this.aux.push(r.text);
      }
    }
    console.log(this.aux);
    this.aux = this.aux.filter((item, index) => {
      return this.aux.indexOf(item) === index;
    });
    if (!this.showZoneFit()) {
      this.zoneFit.forEach((z) => z.isChecked = false);
      this.aux2 = [];
    }
    this.respZone2 = this.zoneFit.filter((t) => t.isChecked == true);
    for (const r of this.respZone2) {
      if (r.isChecked == true) {
        this.aux2.push(r.text);
      }
    }
    console.log(this.aux2);
    this.aux2 = this.aux2.filter((item, index) => {
      return this.aux2.indexOf(item) === index;
    });
    let resp = {
      escala: this.escala,
      commit: this.commit,
      zones: this.aux.toString(),
      zoneFitness: this.aux2.toString(),
      recomendacion: this.opcion,
      objetivo: this.respObj,
    };
    console.log(resp);

    this.common.noFinishSurvey(resp).then((res: any) => {
      console.log(res);
    });
  }

  updateCheck(id) {
    console.log(id);
    for (let item of this.zone) {
      if (item.id == id) {
        console.log(item.isChecked);
        if (item.isChecked == true) {
          item.isChecked = false;
          // this.respZone.push(id)
        } else {
          item.isChecked = true;
          // this.respZone = this.respZone.filter((item) => item !== id);
        }
        // console.log(this.respZone);
      }
    }
    // this.asks[3]={zone:this.aux}
  }

  update(i, t) {
    this.step = 0.4;
    console.log(this.step);
    this.asks = [];
    this.asks[i] = t.value;
    console.log(this.asks[i]);
    this.escala = this.asks[i];
    console.log(this.escala);
    console.log(this.escala);
    if (i >= 0 && i <= 6) {
      this.commit = "";
      this.low = true;
      this.mid = false;
      this.higth = false;
    }

    if (i >= 7 && i <= 8) {
      this.commit = "";
      this.low = false;
      this.mid = true;
      this.higth = false;
    }

    if (i >= 9 && i <= 10) {
      this.commit = "";
      this.low = false;
      this.mid = false;
      this.higth = true;
    }

    console.log(i);
    let resp = {
      escala: i,
      commit: this.commit,
      zones: this.aux.toString(),
      zoneFitness: this.aux2.toString(),
      recomendacion: this.opcion,
      objetivo: this.respObj,
    };

    this.common.noFinishSurvey(resp).then((res: any) => {
      console.log(res);
    });
  }
  toContinue() {
    this.step = 0.5;
  }
  // updateText2(i, t) {
  //   console.log(i, t.target.value);
  //   this.asks[5] = {objetivo:t.target.value};
  // }

  // update(index, field) {
  //   console.log(index);
  //   console.log(field.value);
  //   console.log((this.asks[index] = 1));
  //   this.asks[index] = {recomendacionEscala:field.value};
  //   console.log(this.asks[1]);
  // }
  updateRadio(field) {
    console.log(field.value);
    console.log(this.selectRecomendation);
    this.step = 3;
    this.opcion = field.value;

    let resp = {
      escala: this.escala,
      commit: this.commit,
      zones: this.aux.toString(),
      recomendacion: this.opcion,
      objetivo: this.respObj,
    };
    console.log(resp);

    this.common.noFinishSurvey(resp).then((res: any) => {
      console.log(res);
    });
  }

  save() {
    if (this.escala == undefined) {
      alert("Debe seleccionar una escala de recomendacion");
      return;
    }
    console.log(this.respZone);
    this.aux = this.zone.filter((z) => z.isChecked == true).map((z) => z.text);
    this.aux2 = this.zoneFit.filter((z) => z.isChecked == true).map((z) => z.text);

    let resp = {
      escala: this.escala,
      commit: this.commit,
      zones: this.aux.toString(),
      zoneFitness: this.aux2.toString(),
      recomendacion: this.opcion,
      objetivo: this.respObj,
    };
    console.log(resp);
    this.common.finishSurvey(resp).then((res: any) => {
      if (res.ok == true) {
        if (this.escala > 8) {
          this.router.navigate(["/thanks-promotor", this.centro]);
        } else {
          this.router.navigate(["/thanks"]);
        }
      }
    });
  }
  valuechange(evt) {
    this.step = 1;
    console.log(this.step);
  }
  changeFlag(flag) {
    console.log(flag);
    this.lang = flag;
    this.common.getSurvey(flag).then((res: any) => {
      console.log(res);

      if (res.fields.length == 0) {
        if (this.lang == "esp") {
          this._snackBar.open(
            "No existe traduccion para este cuestionario",
            "Ok",
            {
              duration: 2000,
            }
          );
        } else if (this.lang == "eng") {
          this._snackBar.open("There is no translation for this survey", "Ok", {
            duration: 2000,
          });
        } else if (this.lang == "por") {
          this._snackBar.open("There is no translation for this survey", "Ok", {
            duration: 2000,
          });
        }

        return;
      }
      let ar = [];
      let index = 1;
      let xvalue = null;
      for (let field of res.fields) {
        if (field.type == "numero" || field.type == "escala") {
          xvalue = 0;
        }
        if (field.type == "trueFalse") {
          xvalue = false;
        }
        if (field.type == "textarea") {
          xvalue = "";
        }
        if (field.type == "code-nps") {
          xvalue = null;
        }
        let json = {
          key: "p" + index,
          name: field.name,
          type: field.type,
          value: xvalue,
        };
        ar.push(json);
        index++;
        localStorage.setItem("idioma", field.lang);
      }
      localStorage.setItem("preguntas", JSON.stringify(ar));
      this.questions = ar;
    });
  }
  next() {
    if (this.escala > 8) {
      this.router.navigate(["/thanks-promotor", this.centro]);
    } else {
      this.router.navigate(["/thanks"]);
    }
  }
}
